import { render } from "./VueMention.vue?vue&type=template&id=a3d03976&scoped=true"
import script from "./VueMention.vue?vue&type=script&lang=js"
export * from "./VueMention.vue?vue&type=script&lang=js"

import "./VueMention.vue?vue&type=style&index=0&id=a3d03976&lang=css"
import "./VueMention.vue?vue&type=style&index=1&id=a3d03976&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d03976"]])

export default __exports__